export function clampUnitInterval(value) {
  return Math.min(1, Math.max(0, value));
}
